import React, {PropsWithChildren} from 'react';
import SkipToContent, {SkipToContentProvider} from '../SkipToContent';
import {ImpostorModeProvider} from 'src/components/ImpostorModeContext';
import {RaiseEventListenerProvider} from 'src/components/raise-event-listener-context';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import useUserType from '../../hooks/use-user-type';
import useAsyncEffect from '../../hooks/use-async-effect';
import FeatureInteractionService, {showModalOnce} from '../../services/FeatureInteractionService';
import {showShareDataModal} from '../share-data-modal/utils';
import {useHistory} from 'react-router-dom';
import {CURRENT_FOUR_YEAR_NOT_TRANSFERRING} from '../../views/public/utils/utils';

const atCurrentFourYearNotTransferring = window.sessionStorage.getItem(
  CURRENT_FOUR_YEAR_NOT_TRANSFERRING
);

const modalOptions: [string, string, string] = atCurrentFourYearNotTransferring
  ? (['cant-earn-modal', '/cant-earn', '/home/cant-earn'] as const)
  : (['student-welcome-modal', '/student-welcome', '/home/student-welcome'] as const);

const ApplicationRoot = ({children}: PropsWithChildren) => {
  const history = useHistory();
  const {nonFollowerDataSharing} = useFeatureFlags(['nonFollowerDataSharing']);
  const {isTransfer, isHighSchool} = useUserType();
  const path = history.location.pathname;

  useAsyncEffect(async () => {
    if (nonFollowerDataSharing === undefined) return;
    if (!isTransfer && !isHighSchool) return;

    const prevPath = sessionStorage.getItem('lastVisitedRoute');
    const hasViewedShareDataModal = await FeatureInteractionService.get('share-data-modal', []);

    if (!hasViewedShareDataModal && nonFollowerDataSharing && !path.includes('/onboarding')) {
      showShareDataModal();
    } else if (path === '/home' && prevPath !== '/home/share-data') {
      showModalOnce(...modalOptions);
    }

    sessionStorage.setItem('lastVisitedRoute', path);
  }, [nonFollowerDataSharing, path]);

  return (
    <SkipToContentProvider>
      <ImpostorModeProvider>
        <RaiseEventListenerProvider>
          <SkipToContent />
          {children}
        </RaiseEventListenerProvider>
      </ImpostorModeProvider>
    </SkipToContentProvider>
  );
};

export default ApplicationRoot;
